var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-progress"},[_c('div',{staticClass:"progress-track"},[_c('div',{class:['progress-slider', _vm.ratio < 60 ? 'bgc-FF3C30' : _vm.ratio < 85 ? 'bgc-FFB032' : 'bgc-1DC060'],style:({ height: _vm.ratio + '%' })})]),_c('div',{staticClass:"word-char"},[_vm._v("/"+_vm._s(_vm.phonemeContrastEnum[_vm.content] || '')+"/")])])
}
var staticRenderFns = []

export { render, staticRenderFns }